module.exports = __webpack_public_path__ + "img/tree.d3f02cf3.png";